import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type { FieldInterface } from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const estimateFields: FieldInterface[] = [
  {
    key: 'assetPrice',
    originKey: 'asset_price',
    type: FIELD_TYPES.number,
  },
  {
    key: 'assetPriceMin',
    originKey: 'asset_price_min',
    type: FIELD_TYPES.number,
  },
  {
    key: 'assetPriceMax',
    originKey: 'asset_price_max',
    type: FIELD_TYPES.number,
  },
  {
    key: 'squareMeterPrice',
    originKey: 'square_meter_price',
    type: FIELD_TYPES.number,
  },
  {
    key: 'squareMeterPriceMin',
    originKey: 'square_meter_price_min',
    type: FIELD_TYPES.number,
  },
  {
    key: 'squareMeterPriceMax',
    originKey: 'square_meter_price_max',
    type: FIELD_TYPES.number,
  },
  {
    key: 'confidence',
    originKey: 'confidence',
    type: FIELD_TYPES.string,
  },
  {
    key: 'data',
    originKey: 'data',
    type: FIELD_TYPES.object,
    objectType: 'EstimateModelData',
    objectTypePath: 'src/global-types',
  },
]
